import {
  getEnterpriseId,
  setEnterpriseId,
  setIsTrial,
  getIsTrial,
  getUnauthorized,
  setUnauthorized
} from "@/CommonDP/utils/auth";
import { storage } from "@/CommonDP/utils";
function getObjectFromSessionStorage(name) {
  const json = storage.get(name);
  return json ? JSON.parse(json) : {};
}
function getisShowMyEnterprise(name) {
  return storage.get(name);
}
import request from '@/CommonDP/service/login-service';
import userCenterService from "@/CommonDP/service/userCenter-service";
const enterprise = {
  state: {
    enterpriseId: getEnterpriseId("enterpriseId"),
    enterpriseInfo: getObjectFromSessionStorage("enterpriseInfo"), // 当前企业信息
    isTrial: getIsTrial("isTrial"),
    workBoardPrjId: storage.get("workBoardPrjId"), // 工作台项目看板，项目id
    systemFiling: getObjectFromSessionStorage("systemFiling"),
    unauthorized: getUnauthorized("unauthorized"), // 企业状态 1代表企业能正常使用 110表示当前账号被企业禁用了 4表示企业被禁用了
    activeName: storage.get("activeName"),
    judgeIsUseNewFolder: storage.get("judgeIsUseNewFolder"),
    isShowBranch: getisShowMyEnterprise("isShowBranch") // 企业是否展示分支机构
  },
  mutations: {
    SET_ENTERPRISEID(state, data) {
      state.enterpriseId = data;
      setEnterpriseId(data);
    },
    SET_ENTERPRISEINFO(state, data) {
      state.enterpriseInfo = data;
      storage.set('enterpriseInfo', data ? JSON.stringify(data) : "");
    },
    SET_ISTRIAL(state, data) {
      state.isTrial = data;
      setIsTrial(data);
    },
    SET_WORKBOARDPRJID(state, data) {
      state.workBoardPrjId = data;
      storage.set("workBoardPrjId", data);
    },
    SET_SystemFiling(state, data) {
      state.systemFiling = data;
      storage.set('systemFiling', data ? JSON.stringify(data) : "");
    },
    SET_UNAUTHORIZED(state, data) {
      state.unauthorized = data;
      setUnauthorized(data);
    },
    SET_ACTIVENAME(state, data) {
      state.activeName = data;
      storage.set('activeName', data);
    },
    SET_JUDGEISUSENEWFOLDER(state, data) {
      state.judgeIsUseNewFolder = data;
      storage.set('judgeIsUseNewFolder', data);
    },
    SET_ISSHOW_BRANCH(state, data) {
      state.isShowBranch = data;
      storage.set("isShowBranch", data);
    }
  },
  actions: {
    setEnterpriseId({ commit, dispatch }, data) {
      commit("SET_ENTERPRISEID", data);
      dispatch("setEnterpriseInfo");
    },
    // 设置企业信息
    async setEnterpriseInfo({ commit, state }) {
      const enterpriseId = state.enterpriseId;
      if (enterpriseId) {
        const { data } = await userCenterService.getEnterpriseDetails(enterpriseId);
        const enterpriseInfo = data || {};
        commit("SET_ENTERPRISEINFO", enterpriseInfo);
      }
    },
    setIsTrial({ commit }, data) {
      commit("SET_ISTRIAL", data);
    },
    setWorkBoardPrjId({ commit }, data) {
      commit("SET_WORKBOARDPRJID", data);
    },
    // 获取备案信息和版权信息
    async GetSystemFiling({ commit, state }) {
      const response = await request.getSystemFiling();
      const data = response.data;
      commit('SET_SystemFiling', data);
    },
    setUnauthorized({ commit }, data) {
      commit("SET_UNAUTHORIZED", data);
    },
    setActiveName({ commit }, data) {
      commit("SET_ACTIVENAME", data);
    },
    setJudgeIsUseNewFolder({ commit }, data) {
      commit("SET_JUDGEISUSENEWFOLDER", data);
    },
    setIsShowBranch({ commit }, data) {
      commit("SET_ISSHOW_BRANCH", data);
    }

  }
};
export default enterprise;
